// import IBModuleApi from "../../api/iuviBankingAPI";

export const getConfirmationMessages = async (appId: string) => {
  const data = [
    {
      widgets: ["Payments"],
      ospProcess: "100",
      action: "Action 1",
      idtag: "100",
      ibmessage: "Message IB test 1",
      language: "en",
      releaseversion: "2023.Q3",
      createdat: "2023-09-28T16:15:53.144Z",
      createdby: null,
      updatedat: "2023-09-28T16:14:39.848Z",
      updatedby: "Camilo"
    },
    {
      widgets: ["Tranfers"],
      ospProcess: "200",
      action: "Action 2",
      idtag: "200",
      ibmessage: "Message IB test 2",
      language: "en",
      releaseversion: "2023.Q4",
      createdat: "2023-09-28T16:15:53.144Z",
      createdby: null,
      updatedat: "2023-09-28T16:14:39.848Z",
      updatedby: "Camilo"
    }
  ]

  return data;
};

export const createConfirmationMessages = async (createInfo: any, appId: string) => {
  let data: any;
  return data;
};

export const updateConfirmationMessages = async (updateInfo: any, appId: string) => {
  let data: any;
  return data;
};

export const deleteConfirmationMessages = async (messageId: number) => {
  let data: any;
  return data;
};

export const exportConfirmationMessages = async (info: any) => {
  let data: any;
  return data;
};

export const importConfirmationMessages = async (info: any) => {
  let data: any;
  return data;
};
